import { BaseEntity } from './base-entity';

export interface Country extends BaseEntity {
  code: string;
  name: string;
}

export namespace Country {

  export function equals(country1: Country, country2: Country): boolean {
    return country1 && country2
      ? country1.name === country2.name
      : country1 === country2;
  }
}
